/* eslint-disable max-lines */
import { ReviewStructure } from 'common/components';
import { STORAGE_CDN_PATH } from '../../storage-constants';

export const REVIEWS_DATA: ReviewStructure[] = [
  {
    imagesAlt: 'Review 1',
    images: [`${STORAGE_CDN_PATH}/reviews/review-1-1.jpg/review-1-1.jpg`],
    bigImages: [`storage-mf/reviews/big/review-1-1.jpg/review-1-1.jpg`],
    rating: 4.5,
    text:
      `В небольшой квартире-студии необходима хорошая система хранения.
      Цель была - сделать красиво, удобно и бюджетно.
      Так как старая добрая ИКЕА ушла из России, выбор пал на готовые модульные системы Лемана Про. С итоговым проектированием внутреннего наполнения, выбором фасадов, высотой антресолей помогла определиться специалист Ирина. На момент заказа в наличии не оказалось дверей Лион 193,8 см, но Ирина добавила нас в список ожидания, и когда двери появились, мы их тут же докупили.
      Доставку сделали быструю, всë пришло целое и полным комплектом.
      Сборкой занимались сами.
      Из плюсов:
      Вариативность внутреннего наполнения, приличный выбор фасадов, простые инструкции по сборке.
      Из минусов:
      Монтаж ящиков - сложный и как будто недоработанный (если сравнивать с кухонными), а вот корзины устанавливаются очень быстро. В целом покупкой я довольна, буду смотреть, как покажут себя шкафы в процессе эксплуатации.`,
    date: '9 января 2026',
    store: 'Шолохово',
  },
  {
    imagesAlt: 'Review 2',
    images: [
      `${STORAGE_CDN_PATH}/reviews/review-2-1.jpg/review-2-1.jpg`,
      `${STORAGE_CDN_PATH}/reviews/review-2-2.jpg/review-2-2.jpg`,
    ],
    bigImages: [
      `storage-mf/reviews/big/review-2-1.jpg/review-2-1.jpg`,
      `storage-mf/reviews/big/review-2-2.jpg/review-2-2.jpg`,
    ],
    rating: 5,
    text:
      'Огромная благодарность сотруднику отдела хранения, Елена. За то, что после завершения рабочей смены прошла на встречу и без записей и очередей помогла спроектировать систему хранения в кладовку. Сразу видно, что Елена профессиональную своего дела, все сделала быстро, чётко и я очень доволен конечным результатом.',
    date: '5 декабря 2025',
    store: 'Троицк',
  },
  {
    imagesAlt: 'Review 3',
    images: [
      `${STORAGE_CDN_PATH}/reviews/review-3-1.jpg/review-3-1.jpg`,
      `${STORAGE_CDN_PATH}/reviews/review-3-2.jpg/review-3-2.jpg`,
    ],
    bigImages: [
      `storage-mf/reviews/big/review-3-1.jpg/review-3-1.jpg`,
      `storage-mf/reviews/big/review-3-2.jpg/review-3-2.jpg`,
    ],
    rating: 4.5,
    text:
      'Все было на высшем уровне. Бракованную деталь поменяли быстро',
    date: '22 апреля 2025',
    store: 'Волгоград',
  },
  {
    imagesAlt: 'Review 4',
    images: [
      `${STORAGE_CDN_PATH}/reviews/review-4-1.jpg/review-4-1.jpg`,
    ],
    bigImages: [
      `storage-mf/reviews/big/review-4-1.jpg/review-4-1.jpg`,
    ],
    rating: 5,
    text:
      'Красивая мебель, быстро составили хороший проект и подобрали комплектующие, хороший, ответственный сборщик мебели, ему отдельное спасибо',
    date: '19 июля 2025',
    store: 'Домодедово',
  },
  {
    imagesAlt: 'Review 5',
    images: [`${STORAGE_CDN_PATH}/reviews/review-5-1.jpg/review-5-1.jpg`],
    bigImages: [`storage-mf/reviews/big/review-5-1.jpg/review-5-1.jpg`],
    rating: 5,
    text: 'Проектировка, изготовление, доставка и сборка прошли на высоком уровне, в срок и без замечаний, мы полностью довольны качеством и организацией всего процесса реализации проекта',
    date: '20 января 2025',
    store: 'Зил',
  },
  {
    imagesAlt: 'Review 6',
    images: [
      `${STORAGE_CDN_PATH}/reviews/review-6-1.jpg/review-6-1.jpg`,
    ],
    bigImages: [
      `storage-mf/reviews/big/review-6-1.jpg/review-6-1.jpg`,
    ],
    rating: 5,
    text: `
      Все прошло отлично. Пришли с достаточно нестандартным запросом. Ушли с хорошим проектом углового шкафа для нашей комнаты.\n
      Спасибо консультанту за вдумчивый подход, тщательный подбор углового шкафа и отличное чувство юмора )\n
      Привезли комплект, кстати, на следующий же день - все очень оперативно.\n
      Шкаф собран, самим собирать тяжело, но реально. Благо все схемы и инструкции есть. Выглядит очень симпатично, функционально и современно - все двери с доводчиками. Шкафы вместительные - особенно угловой с зеркалом, там очень много места. Нам нравится. Посмотрим как будет служить.
    `,
    date: '2 марта 2025 ',
    store: 'Владивосток',
  },
  {
    imagesAlt: 'Review 7',
    images: [
      `${STORAGE_CDN_PATH}/reviews/review-7-1.jpg/review-7-1.jpg`,
      `${STORAGE_CDN_PATH}/reviews/review-7-2.jpg/review-7-2.jpg`,
      `${STORAGE_CDN_PATH}/reviews/review-7-3.jpg/review-7-3.jpg`,
      `${STORAGE_CDN_PATH}/reviews/review-7-4.jpg/review-7-4.jpg`,
    ],
    bigImages: [
      `storage-mf/reviews/big/review-7-1.jpg/review-7-1.jpg`,
      `storage-mf/reviews/big/review-7-2.jpg/review-7-2.jpg`,
      `storage-mf/reviews/big/review-7-3.jpg/review-7-3.jpg`,
      `storage-mf/reviews/big/review-7-4.jpg/review-7-4.jpg`,
    ],
    rating: 5,
    text:
      'Сотрудница ответственная, созванивалась, напоминала о проекте, рассказала о скидках, подсказала все. Всем довольны.',
    date: '27 мая 2025',
    store: 'Уфа-2 Планета',
  },
  {
    imagesAlt: 'Review 8',
    images: [
      `${STORAGE_CDN_PATH}/reviews/review-8-1.jpg/review-8-1.jpg`,
      `${STORAGE_CDN_PATH}/reviews/review-8-2.jpg/review-8-2.jpg`,
    ],
    bigImages: [
      `storage-mf/reviews/big/review-8-1.jpg/review-8-1.jpg`,
      `storage-mf/reviews/big/review-8-2.jpg/review-8-2.jpg`,
    ],
    rating: 5,
    text:
      'Это не отдел мебели, а какая-то подписка премиум🥰. Настолько приятно находиться здесь, и, даже если не планировал покупку, обязательно захочешь купить. Консультанты дружелюбные, атмосфера какого-то праздника))) Все так хотям помочь нам😄. Сделали проект гардеробной в наш новый дом. Теперь вы наша любовь навсегда. Ждите, приедем ещё тратить у вас деньги🤗',
    date: '22 июня 2025',
    store: 'Домодедово',
  },
  {
    imagesAlt: 'Review 9',
    images: [
      `${STORAGE_CDN_PATH}/reviews/review-9-1.jpg/review-9-1.jpg`,
      `${STORAGE_CDN_PATH}/reviews/review-9-2.jpg/review-9-2.jpg`,
    ],
    bigImages: [
      `storage-mf/reviews/big/review-9-1.jpg/review-9-1.jpg`,
      `storage-mf/reviews/big/review-9-2.jpg/review-9-2.jpg`,
    ],
    rating: 5,
    text:
      'Меня все устроило и проект и дизайн и сборка',
    date: '12 июня 2025',
    store: 'Ногинск',
  },
  {
    imagesAlt: 'Review 10',
    images: [
      `${STORAGE_CDN_PATH}/reviews/review-10-1.jpg/review-10-1.jpg`,
      `${STORAGE_CDN_PATH}/reviews/review-10-2.jpg/review-10-2.jpg`,
    ],
    bigImages: [
      `storage-mf/reviews/big/review-10-1.jpg/review-10-1.jpg`,
      `storage-mf/reviews/big/review-10-2.jpg/review-10-2.jpg`,
    ],
    rating: 5,
    text:
      'Быстрое и качественное решение вопроса',
    date: '13 декабря 2025',
    store: 'Выхино',
  },
  {
    imagesAlt: 'Review 11',
    images: [
      `${STORAGE_CDN_PATH}/reviews/review-11-1.jpg/review-11-1.jpg`,
    ],
    bigImages: [
      `storage-mf/reviews/big/review-11-1.jpg/review-11-1.jpg`,
    ],
    rating: 5,
    text:
      'Удобная запись, быстро все рассказали, смонтировать.. привезли и сосбрали в тот день когда назначено..',
    date: '30 июля 2025',
    store: 'Воронеж',
  },
  {
    imagesAlt: 'Review 12',
    images: [`${STORAGE_CDN_PATH}/reviews/review-12-1.jpg/review-12-1.jpg`],
    bigImages: [`storage-mf/reviews/big/review-12-1.jpg/review-12-1.jpg`],
    rating: 5,
    text:
      'Заказывала в Леманапро в Краснодаре гардеробную в прихожую. всё понравилось. доставка и сборка была вовремя и без нареканий. сборщики и гардеробной, и дверей-купе мастера своего дела. особое спасибо менеджеру Ирине за составление проекта гардеробной. она очень компетентный работник, учла все мои пожелания и недостатки моего помещения. спасибо большое.',
    date: '22 ноября 2025',
    store: 'Калуга',
  },
  {
    imagesAlt: 'Review 13',
    images: [`${STORAGE_CDN_PATH}/reviews/review-13-1.jpg/review-13-1.jpg`],
    bigImages: [`storage-mf/reviews/big/review-13-1.jpg/review-13-1.jpg`],
    rating: 4.5,
    text:
      'Все отлично . Огромное спасибо команде . Сборщики доставщики проектировщики и консультанты. Все решили помогли очень быстро.',
    date: '21 мая 2025',
    store: 'Ростов-на-Дону-1 (Мега)',
  },
  {
    imagesAlt: 'Review 14',
    images: [`${STORAGE_CDN_PATH}/reviews/review-14-1.jpg/review-14-1.jpg`],
    bigImages: [`storage-mf/reviews/big/review-14-1.jpg/review-14-1.jpg`],
    rating: 5,
    text:
      'Работа с отличным специалистом планировщиком по системам хранения Мариной Волковой. Всю систему хранения и шкафы Лион покупали в Лемана Про. Качество хорошее, всё устраивает. Хорошая сборка - отличный, очень ответственный мастер.',
    date: '20 июня 2025',
    store: 'Челябинск',
  },
  {
    imagesAlt: 'Review 15',
    images: [`${STORAGE_CDN_PATH}/reviews/review-15-1.jpg/review-15-1.jpg`],
    bigImages: [`storage-mf/reviews/big/review-15-1.jpg/review-15-1.jpg`],
    rating: 4.5,
    text:
      'Широкий выбор на любой вкус, хорошее качество товара, бесплатные доп. услуги ( проект, подбор) , дешёвая доставка. Всё супер',
    date: '29 августа 2025',
    store: 'Люберцы',
  },
];
